import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, withKeys as _withKeys, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, resolveDirective as _resolveDirective } from "vue"
import _imports_0 from '../assets/account.png'


const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = {
  key: 0,
  class: "login-status-change-tip"
}
const _hoisted_3 = { class: "tip-actions" }
const _hoisted_4 = {
  key: 1,
  class: "loading-screen"
}
const _hoisted_5 = { class: "desktop-login-wrapper" }
const _hoisted_6 = { class: "login-form-section" }
const _hoisted_7 = { class: "section-content" }
const _hoisted_8 = { class: "login-form" }
const _hoisted_9 = {
  key: "method-select",
  class: "email-step"
}
const _hoisted_10 = { class: "login-method-buttons" }
const _hoisted_11 = {
  key: "password-form",
  class: "email-step"
}
const _hoisted_12 = {
  key: "pin-code",
  class: "email-step code-step"
}
const _hoisted_13 = { class: "code-sent-info" }
const _hoisted_14 = { class: "code-sent-row" }
const _hoisted_15 = { class: "code-sent-email" }
const _hoisted_16 = { class: "pin-code-container" }
const _hoisted_17 = ["value", "onInput", "onKeydown", "onFocus"]
const _hoisted_18 = { class: "code-actions" }
const _hoisted_19 = {
  key: 0,
  class: "code-countdown-text"
}
const _hoisted_20 = {
  key: 0,
  class: "login-actions"
}
const _hoisted_21 = { class: "helper-links" }
const _hoisted_22 = { class: "third-party-login" }
const _hoisted_23 = { class: "third-party-icons" }
const _hoisted_24 = { style: {"display":"none"} }
const _hoisted_25 = { class: "section-header wechat-header" }
const _hoisted_26 = { class: "section-content wechat-content" }
const _hoisted_27 = { class: "wechat-qr-wrapper" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "wechat-info" }
const _hoisted_30 = {
  key: 0,
  class: "wechat-countdown"
}
const _hoisted_31 = { class: "countdown-text" }
const _hoisted_32 = {
  key: 1,
  class: "wechat-code-display"
}
const _hoisted_33 = { class: "code-value" }
const _hoisted_34 = {
  key: 0,
  class: "wechat-status"
}
const _hoisted_35 = {
  key: 0,
  class: "status-confirmed"
}
const _hoisted_36 = {
  key: 1,
  class: "status-expired"
}
const _hoisted_37 = {
  key: 2,
  class: "status-register"
}
const _hoisted_38 = {
  key: 0,
  class: "register-countdown-text"
}
const _hoisted_39 = { class: "countdown-number" }
const _hoisted_40 = { class: "register-actions-compact" }
const _hoisted_41 = { class: "login-header" }
const _hoisted_42 = { class: "login-tabs" }
const _hoisted_43 = {
  key: "account",
  class: "login-form"
}
const _hoisted_44 = {
  key: "method-select-mobile",
  class: "email-step"
}
const _hoisted_45 = { class: "login-method-buttons" }
const _hoisted_46 = {
  key: "password-form-mobile",
  class: "email-step"
}
const _hoisted_47 = {
  key: "pin-code-mobile",
  class: "email-step code-step"
}
const _hoisted_48 = { class: "code-sent-info" }
const _hoisted_49 = { class: "code-sent-row" }
const _hoisted_50 = { class: "code-sent-email" }
const _hoisted_51 = { class: "pin-code-container" }
const _hoisted_52 = ["value", "onInput", "onKeydown", "onFocus"]
const _hoisted_53 = { class: "code-actions" }
const _hoisted_54 = {
  key: 0,
  class: "code-countdown-text"
}
const _hoisted_55 = {
  key: "miniprogram",
  class: "miniprogram-form"
}
const _hoisted_56 = { class: "miniprogram-container" }
const _hoisted_57 = { class: "miniprogram-wrapper" }
const _hoisted_58 = { class: "miniprogram-display" }
const _hoisted_59 = { class: "miniprogram-qr-section" }
const _hoisted_60 = ["src"]
const _hoisted_61 = {
  key: 2,
  class: "countdown-display"
}
const _hoisted_62 = { class: "countdown-text" }
const _hoisted_63 = {
  key: 0,
  class: "miniprogram-code-box"
}
const _hoisted_64 = { class: "code-value" }
const _hoisted_65 = { class: "code-chunk" }
const _hoisted_66 = { class: "code-chunk" }
const _hoisted_67 = {
  key: 1,
  class: "miniprogram-status"
}
const _hoisted_68 = {
  key: 0,
  class: "status-confirmed"
}
const _hoisted_69 = {
  key: 1,
  class: "status-expired"
}
const _hoisted_70 = {
  key: 2,
  class: "status-register"
}
const _hoisted_71 = {
  key: 0,
  class: "register-countdown-text"
}
const _hoisted_72 = { class: "countdown-number" }
const _hoisted_73 = { class: "register-actions" }
const _hoisted_74 = {
  key: 0,
  class: "action-buttons"
}
const _hoisted_75 = {
  key: 0,
  class: "login-actions"
}
const _hoisted_76 = { class: "helper-links" }
const _hoisted_77 = { class: "third-party-login" }
const _hoisted_78 = { class: "third-party-icons" }
const _hoisted_79 = { style: {"display":"none"} }

import { ref, reactive, onMounted, onBeforeMount, watch, onUnmounted, computed, nextTick } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { useRouter } from 'vue-router';
import { useUserStore } from '@/store/user';
import { useSharedStore } from '@/store/shared';
import request from '@/utils/request';
import { User, Lock, Message, Key, View, Hide } from '@element-plus/icons-vue';
import type { FormInstance } from 'element-plus';
import { config } from '@/config'
import GeetestCaptcha from '@/components/GeetestCaptcha.vue';
import { LogoQqIcon } from 'tdesign-icons-vue-next';

const MAX_RETRIES = 3;


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  emits: ['animation-complete'],
  setup(__props, { emit: __emit }) {

/* eslint-disable no-undef */
const router = useRouter();
const userStore = useUserStore();
const sharedStore = useSharedStore();

// 新增：登录状态变化提示相关
const showLoginStatusChangeTip = ref(false);

// PC 端检测
const windowWidth = ref(typeof window !== 'undefined' ? window.innerWidth : 1024);
const isDesktop = computed(() => windowWidth.value >= 1024);

// 侧边面板显示控制（动画延迟）
const sidePanelsVisible = ref(false);

const currentMethod = ref('account');

const formData = reactive({
  username: sharedStore.email || '',
  password: '',
});

const emailFormData = reactive({
  email: sharedStore.email || '',
  code: '',
});

const loading = ref(false);
const sendingCode = ref(false);
const passkeyLoginLoading = ref(false);
const showPasswordField = ref(false);

// 小程序扫码登录相关
const miniprogramLoading = ref(false);
const miniprogramStatus = ref('waiting'); // waiting, confirmed, expired, register
const miniprogramScene = ref('');
const miniprogramQrImage = ref('');
const miniprogramCode = ref('');
const miniprogramSecretKey = ref(''); // 客户端绑定密钥，用于轮询时验证身份
const pollTimer = ref<ReturnType<typeof setInterval> | null>(null);
const pendingWechatData = ref<any>(null);
const isGeneratingCode = ref(false); // 防止重复生成验证码
const miniprogramCountdown = ref(0); // 小程序验证码倒计时
const miniprogramCountdownTimer = ref<ReturnType<typeof setInterval> | null>(null);
const registerCountdown = ref(0); // 新用户注册倒计时
const registerCountdownTimer = ref<ReturnType<typeof setInterval> | null>(null);

const rules = {
  username: [
    { required: true, message: '请输入用户名或邮箱', trigger: 'blur' },
    { 
      validator: (rule: any, value: string, callback: any) => {
        if (value.includes('@')) {
          // 如果是邮箱格式，使用邮箱验证
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(value)) {
            callback(new Error('请输入正确的邮箱格式'));
          }
        } else if (value.length < 3) {
          callback(new Error('用户名建议不少于3个字符'));
        }
        callback();
      },
      trigger: 'blur'
    }
  ],
  password: [
    { required: true, message: '请输入密码', trigger: 'blur' },
    { min: 6, max: 20, message: '密码长度为6-20位', trigger: 'blur' },
  ],
};

const emailRules = {
  email: [
    { required: true, message: '请输入邮箱', trigger: 'blur' },
    { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' },
  ],
  code: [
    { required: true, message: '请输入验证码', trigger: 'blur' },
    { len: 6, message: '验证码长度为6位', trigger: 'blur' },
  ],
};

const countdown = ref(0);
const startCountdown = () => {
  countdown.value = 60;
  const timer = setInterval(() => {
    countdown.value--;
    if (countdown.value <= 0) {
      clearInterval(timer);
    }
  }, 1000);
};



// 旧弹窗方式已移除，改为 bind 触发



// 已不使用的第三方登录占位方法移除

const handleGoogleLogin = () => {
  const state = Math.random().toString(36).slice(2)
  localStorage.setItem('google_login_state', state)
  
  // 保存当前的 redirect 参数，以便登录后能回到授权页面
  const redirect = router.currentRoute.value.query.redirect as string
  if (redirect) {
    localStorage.setItem('oauth_login_redirect', redirect)
  }
  
  const url = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${encodeURIComponent(config.google.clientId)}&redirect_uri=${encodeURIComponent(config.google.redirectUri)}&response_type=code&scope=${encodeURIComponent(config.google.scope)}&state=${encodeURIComponent(state)}`
  window.location.href = url
}

const handleGithubLogin = () => {
  const state = Math.random().toString(36).slice(2)
  localStorage.setItem('github_login_state', state)
  
  // 保存当前的 redirect 参数，以便登录后能回到授权页面
  const redirect = router.currentRoute.value.query.redirect as string
  if (redirect) {
    localStorage.setItem('oauth_login_redirect', redirect)
  }
  
  const url = `https://github.com/login/oauth/authorize?client_id=${encodeURIComponent(config.github.clientId)}&redirect_uri=${encodeURIComponent(config.github.redirectUri)}&scope=${encodeURIComponent(config.github.scope)}&state=${encodeURIComponent(state)}`
  window.location.href = url
}

const goToRegister = () => {
  // 保留当前输入的邮箱信息
  if (formData.username && formData.username.includes('@')) {
    sharedStore.setEmail(formData.username);
  }
  router.push('/register');
};

const accountFormRef = ref<FormInstance>();
const emailFormRef = ref<FormInstance>();
// bind 模式隐藏实例引用
const accountBindGeetestRef = ref<InstanceType<typeof GeetestCaptcha>>();
const emailBindGeetestRef = ref<InstanceType<typeof GeetestCaptcha>>();
const emailCodeInputRef = ref<any>();

const emailCodeSent = ref(false);
const emailCodeDigits = ref<string[]>(['', '', '', '', '', '']);
const pinRefs = ref<(HTMLInputElement | null)[]>(new Array(6).fill(null));

const setPinRef = (el: any, index: number) => {
  if (el) pinRefs.value[index] = el as HTMLInputElement;
};

const handlePinInput = (index: number, event: Event) => {
  const input = event.target as HTMLInputElement;
  const value = input.value.replace(/\D/g, '');
  emailCodeDigits.value[index] = value.slice(-1);
  emailFormData.code = emailCodeDigits.value.join('');

  if (value && index < 5) {
    nextTick(() => pinRefs.value[index + 1]?.focus());
  }

  if (emailCodeDigits.value.every(d => d) && emailFormData.code.length === 6) {
    nextTick(() => pinRefs.value[5]?.blur());
    setTimeout(() => handleSubmit(), 300);
  }
};

const handlePinKeydown = (index: number, event: KeyboardEvent) => {
  if (event.key === 'Backspace') {
    if (!emailCodeDigits.value[index] && index > 0) {
      emailCodeDigits.value[index - 1] = '';
      emailFormData.code = emailCodeDigits.value.join('');
      nextTick(() => pinRefs.value[index - 1]?.focus());
    }
  } else if (event.key === 'ArrowLeft' && index > 0) {
    pinRefs.value[index - 1]?.focus();
  } else if (event.key === 'ArrowRight' && index < 5) {
    pinRefs.value[index + 1]?.focus();
  } else if (event.key === 'Enter') {
    handleSubmit();
  }
};

const handlePinPaste = (event: ClipboardEvent) => {
  event.preventDefault();
  const paste = event.clipboardData?.getData('text')?.replace(/\D/g, '').slice(0, 6);
  if (!paste) return;

  for (let i = 0; i < 6; i++) {
    emailCodeDigits.value[i] = paste[i] || '';
  }
  emailFormData.code = emailCodeDigits.value.join('');

  nextTick(() => {
    const nextEmpty = emailCodeDigits.value.findIndex(d => !d);
    if (nextEmpty >= 0) {
      pinRefs.value[nextEmpty]?.focus();
    } else {
      pinRefs.value[5]?.focus();
    }
  });

  if (paste.length === 6) {
    setTimeout(() => handleSubmit(), 300);
  }
};

const handlePinFocus = (index: number) => {
  pinRefs.value[index]?.select();
};

const resetEmailCodeStep = () => {
  emailCodeSent.value = false;
  emailCodeDigits.value = ['', '', '', '', '', ''];
  emailFormData.code = '';
  showPasswordField.value = false;
};

const isEmailFormat = computed(() => {
  const val = formData.username;
  return val && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
});

const startEmailCodeLogin = () => {
  if (!formData.username) {
    ElMessage.warning('请先输入邮箱地址');
    return;
  }
  if (!isEmailFormat.value) {
    ElMessage.warning('当前输入不是邮箱，如需邮箱验证码登录，请输入邮箱地址');
    return;
  }
  emailFormData.email = formData.username;
  sharedStore.setEmail(formData.username);
  triggerEmailSendCodeCaptcha();
};

// 修复首次进入页面时验证码按钮可能未渲染的问题：在动画完成/容器显示后刷新一次
const refreshCaptchas = () => {
  // bind 模式无需刷新占位
};

// 删除占位相关状态

// 区分邮箱 bind 验证用途：sendCode | login
const emailBindPurpose = ref<'sendCode' | 'login'>('sendCode');

// 触发邮箱验证码发送的 bind 模式验证码
const triggerEmailSendCodeCaptcha = async () => {
  try {
    if (!emailCodeSent.value) {
      if (emailFormRef.value) {
        await emailFormRef.value.validateField('email');
      } else if (!emailFormData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailFormData.email)) {
        ElMessage.error('请输入正确的邮箱格式');
        return;
      }
    }
    emailBindPurpose.value = 'sendCode';
    emailBindGeetestRef.value?.show?.();
  } catch (error: any) {
    ElMessage.error(error.message || '验证失败');
  }
};

// bind 成功回调：账号密码登录
const onAccountBindSuccess = async (payload: any) => {
  try {
    loading.value = true;
    await userStore.login({
      username: formData.username,
      password: formData.password,
      lotNumber: payload.lotNumber,
      captchaOutput: payload.captchaOutput,
      passToken: payload.passToken,
      genTime: payload.genTime
    });
    formData.password = '';
    ElMessage.success('登录成功');
    const redirect = (router.currentRoute.value.query.redirect as string) || '/profile';
    router.push(redirect.startsWith('/login') ? '/profile' : redirect);
  } catch (error: any) {
    ElMessage.error(error.message || '登录失败');
  } finally {
    loading.value = false;
  }
};

// bind 成功回调：邮箱验证码发送 / 邮箱登录
const onEmailBindSuccess = async (payload: any) => {
  try {
    if (emailBindPurpose.value === 'sendCode') {
      sendingCode.value = true;
      await userStore.sendEmailCodeWithGeetest({
        email: emailFormData.email,
        lotNumber: payload.lotNumber,
        captchaOutput: payload.captchaOutput,
        passToken: payload.passToken,
        genTime: payload.genTime
      });
      ElMessage.success('验证码已发送');
      startCountdown();
      emailCodeSent.value = true;
      emailCodeDigits.value = ['', '', '', '', '', ''];
      emailFormData.code = '';
      setTimeout(() => { pinRefs.value[0]?.focus(); }, 500);
    } else {
      loading.value = true;
      const loginData = {
        email: emailFormData.email,
        code: emailFormData.code,
        lotNumber: payload.lotNumber,
        captchaOutput: payload.captchaOutput,
        passToken: payload.passToken,
        genTime: payload.genTime
      };
      await userStore.loginWithEmail(loginData);
      emailFormData.code = '';
      ElMessage.success('登录成功');
      const redirect = (router.currentRoute.value.query.redirect as string) || '/profile';
      router.push(redirect.startsWith('/login') ? '/profile' : redirect);
    }
  } catch (error: any) {
    ElMessage.error(error.message || (emailBindPurpose.value === 'sendCode' ? '发送验证码失败' : '登录失败'));
  } finally {
    if (emailBindPurpose.value === 'sendCode') {
      sendingCode.value = false;
    } else {
      loading.value = false;
    }
    emailBindPurpose.value = 'sendCode';
  }
};

// 通行密钥登录（发现模式，不需要用户名）
const handlePasskeyLogin = async () => {
  try {
    passkeyLoginLoading.value = true
    
    // 1. 开始登录，获取挑战（发现模式，不需要用户名）
    const options = await userStore.startPasskeyLogin()
    
    // 2. 转换选项格式为 WebAuthn API 需要的格式
    // 将 Base64URL 转换为 Base64，然后解码（需要添加填充）
    const base64UrlToBase64 = (base64Url: string): string => {
      let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
      // 添加填充
      while (base64.length % 4) {
        base64 += '='
      }
      return base64
    }
    
    const publicKeyCredentialRequestOptions: any = {
      challenge: Uint8Array.from(atob(base64UrlToBase64(options.challenge)), c => c.charCodeAt(0)),
      timeout: options.timeout,
      userVerification: options.userVerification || 'preferred'
    }
    
    // 发现模式：不传 allowCredentials，让浏览器自动发现所有可用的通行密钥
    if (options.allowCredentials && options.allowCredentials.length > 0) {
      publicKeyCredentialRequestOptions.allowCredentials = options.allowCredentials.map((cred: any) => ({
        id: Uint8Array.from(atob(base64UrlToBase64(cred.id)), c => c.charCodeAt(0)),
        type: cred.type
      }))
    }
    
    // 3. 调用 WebAuthn API 获取断言
    const assertion = await navigator.credentials.get({
      publicKey: publicKeyCredentialRequestOptions
    }) as any
    
    if (!assertion) {
      throw new Error('通行密钥验证失败')
    }
    
    // 4. 转换响应为 Base64URL
    const response = assertion.response as any
    
    // 将 ArrayBuffer 转换为 Base64URL
    const arrayBufferToBase64 = (buffer: ArrayBuffer): string => {
      const bytes = new Uint8Array(buffer)
      let binary = ''
      for (let i = 0; i < bytes.length; i++) {
        binary += String.fromCharCode(bytes[i])
      }
      return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')
    }
    
    const assertionBase64 = {
      id: assertion.id, // 已经是 Base64URL
      response: {
        clientDataJSON: arrayBufferToBase64(response.clientDataJSON),
        authenticatorData: arrayBufferToBase64(response.authenticatorData),
        signature: arrayBufferToBase64(response.signature)
      }
    }
    
    // 5. 完成登录
    await userStore.finishPasskeyLogin(
      options.challenge,
      JSON.stringify(assertionBase64)
    )
    
    ElMessage.success('登录成功')
    formData.password = ''
    const redirect = (router.currentRoute.value.query.redirect as string) || '/profile'
    router.push(redirect.startsWith('/login') ? '/profile' : redirect)
  } catch (error: any) {
    console.error('通行密钥登录失败:', error)
    if (error.name === 'NotAllowedError') {
      ElMessage.error('操作被取消或设备不支持')
    } else if (error.name === 'InvalidStateError') {
      ElMessage.error('通行密钥验证失败，请重试')
    } else {
      // 使用通用错误信息，不显示具体错误原因
      ElMessage.error('无法使用通行密钥登录，可能是设备不支持')
    }
  } finally {
    passkeyLoginLoading.value = false
  }
}

// 生成小程序码（无需极验）
const generateMiniprogramCode = async () => {
    if (isGeneratingCode.value) return;
  try {
    isGeneratingCode.value = true;
    miniprogramLoading.value = true;
    miniprogramStatus.value = 'waiting';
    const response = await request.post('/auth/miniprogram-login/generate');
    const responseData = response as any;
    if (responseData.code === 200 && responseData.data) {
      miniprogramScene.value = responseData.data.scene;
      miniprogramQrImage.value = responseData.data.qrCodeImage || '';
      miniprogramCode.value = responseData.data.verificationCode || responseData.data.scene || '';
      miniprogramSecretKey.value = responseData.data.secretKey || ''; // 保存客户端绑定密钥
      startPolling();
      startMiniprogramCountdown();
    } else {
      ElMessage.error(responseData.message || '生成小程序码失败');
    }
  } catch (error: any) {
    ElMessage.error('生成小程序码失败');
  } finally {
    miniprogramLoading.value = false;
    isGeneratingCode.value = false;
  }
};

const selectPasswordLogin = () => {
  if (!formData.username) {
    ElMessage.warning('请先输入邮箱或用户名');
    return;
  }
  showPasswordField.value = true;
};

const backToMethodSelect = () => {
  showPasswordField.value = false;
  formData.password = '';
};

const handleSubmit = async () => {
  try {
    if (loading.value) return;
    
    if (emailCodeSent.value) {
      if (emailFormData.code.length !== 6) {
        ElMessage.warning('请输入完整的6位验证码');
        return;
      }
      emailBindPurpose.value = 'login';
      emailBindGeetestRef.value?.show?.();
    } else if (showPasswordField.value) {
      if (!accountFormRef.value) return;
      await accountFormRef.value.validate();
      accountBindGeetestRef.value?.show?.();
    }
  } catch (error: any) {
    ElMessage.error({
      message: error.message || '登录失败',
      grouping: true
    });
  }
};

const animationComplete = ref(false);

const emit = __emit

const logoLoaded = ref(false);
const logoRef = ref<HTMLImageElement | null>(null);
const logoLoadRetries = ref(0);
const handleLogoLoaded = () => {
  logoLoaded.value = true;
  startLoginAnimation();
};

const handleLogoError = () => {
  logoLoadRetries.value++;
  if (logoLoadRetries.value <= MAX_RETRIES) {
    ElMessage.warning('加载失败，正在重试...');
    // 强制重新加载
    setTimeout(() => {
      if (logoRef.value) {
        // 通过修改DOM元素的src属性来强制重新加载
        const timestamp = Date.now();
        logoRef.value.src = `../assets/account.png?t=${timestamp}`;
      }
    }, 500);
  } else {
    logoLoaded.value = true;
    ElMessage.error('加载失败，请检查图片文件');
    startLoginAnimation();
  }
};

const startLoginAnimation = () => {
  setTimeout(() => {
    animationComplete.value = true;
    setTimeout(() => {
      emit('animation-complete');
      // 动画完成后再次刷新一次验证码，确保容器可见后实例渲染
      setTimeout(refreshCaptchas, 100);
      
      // PC 端：动画完成后延迟显示微信登录面板
      if (isDesktop.value) {
        setTimeout(() => {
          sidePanelsVisible.value = true;
          // 自动生成微信小程序码
          if (!miniprogramQrImage.value && !miniprogramLoading.value) {
            generateMiniprogramCode();
          }
        }, 300);
      }
    }, 1000);
  }, 600);
};

// 监听窗口大小变化
const handleResize = () => {
  windowWidth.value = window.innerWidth;
};

// 接收 iframe 内 QQCallback 的消息，完成登录
// 初始状态下，图片未加载完成，显示加载屏幕
onMounted(() => {
  // 添加超时处理，避免用户长时间等待
  setTimeout(() => {
    if (!logoLoaded.value) {
      logoLoaded.value = true;
      ElMessage.warning('图片加载超时，已为您显示页面');
      startLoginAnimation();
    }
  }, 2000);
  // 初次渲染后，延迟刷新验证码实例，避免首次渲染未挂载导致不显示
  // 移除内嵌实例刷新
  
  // 监听窗口大小变化
  window.addEventListener('resize', handleResize);
});

const showPassword = ref(false);

// 新增：刷新页面方法
const refreshPage = () => {
  window.location.reload();
};

// 新增：忽略提示方法
const dismissTip = () => {
  showLoginStatusChangeTip.value = false;
  sharedStore.clearLoginStatusChanged();
};

// 新增：检查登录状态变化
const checkLoginStatusChange = () => {
  if (sharedStore.loginStatusChanged) {
    showLoginStatusChangeTip.value = true;
  }
};

// 新增：初始化登录状态监听
const initLoginStatusListener = () => {
  // 初始化共享状态监听器
  sharedStore.initLoginStatusListener();
  
  // 监听自定义登录状态变化事件
  window.addEventListener('loginStatusChanged', () => {
    // 延迟检查，确保状态已更新
    setTimeout(() => {
      checkLoginStatusChange();
    }, 100);
  });
  
  // 页面可见性变化时检查状态
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      // 页面变为可见时，检查登录状态
      setTimeout(() => {
        checkLoginStatusChange();
      }, 100);
    }
  });
};

onBeforeMount(async () => {
  // 检查是否有错误参数（从授权页面跳转过来）
  const route = router.currentRoute.value
  if (route.query.error === 'token_expired') {
    ElMessage.error(route.query.error_description as string || '登录已过期，请重新登录')
  }
  
  if (userStore.token) {
    try {
      await userStore.checkAuth()
      const redirect = (route.query.redirect as string) || '/profile'
      router.replace(redirect)
    } catch (error) {
      // token 无效，清除登录状态
      userStore.logout()
    }
  }
  
  // 新增：初始化登录状态监听
  initLoginStatusListener();
  
  // 新增：检查登录状态变化
  setTimeout(() => {
    checkLoginStatusChange();
  }, 100);
})

const showPasswordRecoveryTip = () => {
  ElMessageBox.alert(
    '请使用邮箱验证码登录后修改密码，或重新注册新账号，如有特别情况，请联系 accountrecovery@qifalab.com',
    '找回密码提示',
    {
      confirmButtonText: '知道了',
      type: 'info'
    }
  ).catch(() => {
    // 用户点击关闭按钮时的处理
    // 这里可以为空，但需要catch来防止报错
  })
}

const handleQQLogin = () => {
  // 生成随机state用于防止CSRF攻击
  const state = Math.random().toString(36).substring(7);
  localStorage.setItem('qq_login_state', state);
  
  // 保存当前的 redirect 参数，以便登录后能回到授权页面
  const redirect = router.currentRoute.value.query.redirect as string;
  if (redirect) {
    localStorage.setItem('oauth_login_redirect', redirect);
  }
  
  // 直接跳转到 QQ 授权页面（不使用 SDK，避免冲突）
  const params = new URLSearchParams({
    response_type: 'token',
    client_id: config.qq.appId,
    redirect_uri: config.qq.redirectUri,
    scope: 'get_user_info',
    state: state
  });
  
  window.location.href = `https://graph.qq.com/oauth2.0/authorize?${params.toString()}`;
};

// 监听username变化，如果是邮箱格式则同步到email字段和共享存储
watch(() => formData.username, (newValue) => {
  if (newValue && newValue.includes('@')) {
    emailFormData.email = newValue;
    sharedStore.setEmail(newValue);
  }
});

// 监听email变化，同步到共享存储
watch(() => emailFormData.email, (newValue) => {
  if (newValue) {
    sharedStore.setEmail(newValue);
  }
});

// 监听登录方式变化：进入小程序登录时自动获取一次小程序码，离开时停止计时/轮询
watch(() => currentMethod.value, (newMethod, oldMethod) => {
  if (newMethod === 'miniprogram') {
    miniprogramStatus.value = 'waiting';
    // 仅在当前没有有效小程序码时自动生成，避免重复刷新
    if (!miniprogramQrImage.value && !miniprogramLoading.value) {
      generateMiniprogramCode();
    }
  } else if (oldMethod === 'miniprogram') {
    stopMiniprogramCountdown();
    stopPolling();
    miniprogramCode.value = '';
    miniprogramQrImage.value = '';
    miniprogramScene.value = '';
    miniprogramStatus.value = 'waiting';
  }
});

const handleClearUsername = () => {
  // 无论用户名是什么格式，都清除共享存储
  sharedStore.clearEmail();
  // 同步清除邮箱登录方式的邮箱
  emailFormData.email = '';
};

const handleClearEmail = () => {
  // 清除共享存储
  sharedStore.clearEmail();
  // 同步清除账号密码登录方式的邮箱
  if (formData.username.includes('@')) {
    formData.username = '';
  }
};

// 小程序扫码登录相关方法：
// 页面加载时不主动生成，由切换到“小程序登录”Tab 时自动生成

const formatCountdown = (seconds: number) => {
  if (seconds <= 0) return '';
  const min = Math.floor(seconds / 60);
  const sec = seconds % 60;
  if (min > 0) return `${min}:${sec.toString().padStart(2, '0')}`;
  return `${sec}秒`;
};

// 开始小程序验证码倒计时
const startMiniprogramCountdown = () => {
  miniprogramCountdown.value = 300; // 5分钟倒计时
  miniprogramCountdownTimer.value = setInterval(() => {
    miniprogramCountdown.value--;
    if (miniprogramCountdown.value <= 0) {
      if (miniprogramCountdownTimer.value) {
        clearInterval(miniprogramCountdownTimer.value);
        miniprogramCountdownTimer.value = null;
      }
      miniprogramQrImage.value = '';
      miniprogramCode.value = '';
      miniprogramScene.value = '';
      miniprogramStatus.value = 'expired';
      if (pollTimer.value) {
        clearInterval(pollTimer.value);
        pollTimer.value = null;
      }
    }
  }, 1000);
};

// 停止小程序验证码倒计时
const stopMiniprogramCountdown = () => {
  if (miniprogramCountdownTimer.value) {
    clearInterval(miniprogramCountdownTimer.value);
    miniprogramCountdownTimer.value = null;
  }
  miniprogramCountdown.value = 0;
};

// 开始新用户注册倒计时
const startRegisterCountdown = () => {
  stopRegisterCountdown(); // 先清除可能存在的倒计时
  registerCountdown.value = 10; // 10秒倒计时
  registerCountdownTimer.value = setInterval(() => {
    registerCountdown.value--;
    if (registerCountdown.value <= 0) {
      stopRegisterCountdown();
      // 倒计时结束，自动注册
      confirmRegister();
    }
  }, 1000);
};

// 停止新用户注册倒计时
const stopRegisterCountdown = () => {
  if (registerCountdownTimer.value) {
    clearInterval(registerCountdownTimer.value);
    registerCountdownTimer.value = null;
  }
  registerCountdown.value = 0;
};

// bind 模式已直接触发，不需要占位回调

// 小程序码生成逻辑已内聚到 generateMiniprogramCode 中，无需额外占位回调

const startPolling = () => {
  if (pollTimer.value) {
    clearInterval(pollTimer.value);
  }
  
  pollTimer.value = setInterval(async () => {
    try {
      const response = await request.get(`/auth/miniprogram-login/status/${miniprogramScene.value}?flow=login&secretKey=${miniprogramSecretKey.value}`);
      
      const responseData = response as any;
      if (responseData.code === 200) {
        const { status, token, user, message } = responseData.data;
        
        if (status === 'confirmed' && token && user) {
          // 登录成功
          miniprogramStatus.value = 'confirmed';
          stopPolling();
          userStore.token = token;
          userStore.userInfo = user;
          localStorage.setItem('token', token);
          
          // 新增：通知其他标签页登录状态变化
          userStore.notifyLoginStatusChange();
          
          ElMessage.success('登录成功');
          const redirect = (router.currentRoute.value.query.redirect as string) || '/profile';
          router.push(redirect.startsWith('/login') ? '/profile' : redirect);
        } else if (status === 'expired') {
          miniprogramStatus.value = 'expired';
          miniprogramQrImage.value = ''; // 清空二维码，激活重新获取逻辑
          stopPolling();
        } else if (status === 'register_required') {
          // 需要注册新账号
          miniprogramStatus.value = 'register';
          pendingWechatData.value = { code: miniprogramScene.value };
          stopPolling();
          // 启动10秒倒计时，倒计时结束自动注册
          startRegisterCountdown();
        } else if (status === 'forbidden') {
          stopPolling();
          ElMessage.error(message || '该用户不可用，请联系管理员');
        }
      }
    } catch (error) {
      console.error('轮询登录状态失败:', error);
    }
  }, 5000); // 每5秒轮询一次，减轻服务器压力并避免重复提示
};

const stopPolling = () => {
  if (pollTimer.value) {
    clearInterval(pollTimer.value);
    pollTimer.value = null;
  }
  // 停止倒计时
  stopMiniprogramCountdown();
};

const cancelRegister = () => {
  stopRegisterCountdown(); // 停止注册倒计时
  miniprogramStatus.value = 'waiting';
  pendingWechatData.value = null;
  stopMiniprogramCountdown(); // 停止小程序码倒计时
  generateMiniprogramCode(); // 重新生成验证码
};

const confirmRegister = async () => {
  try {
    if (!pendingWechatData.value) {
      ElMessage.error('微信数据缺失');
      return;
    }
    
    // 停止倒计时（无论是手动点击还是自动触发）
    stopRegisterCountdown();
    loading.value = true;
    
    // 调用注册接口
    const response = await request.post('/auth/register/wechat', {
      wechat_data: pendingWechatData.value
    });
    
    const responseData = response as any;
    if (responseData.code === 200) {
      // 注册成功，自动登录
      userStore.token = responseData.data.token;
      userStore.userInfo = responseData.data.user;
      localStorage.setItem('token', responseData.data.token);
      
      // 新增：通知其他标签页登录状态变化
      userStore.notifyLoginStatusChange();
      
      ElMessage.success('注册并登录成功');
      
      const redirect = (router.currentRoute.value.query.redirect as string) || '/profile';
      router.push(redirect.startsWith('/login') ? '/profile' : redirect);
    } else {
      ElMessage.error(responseData.message || '注册失败');
    }
  } catch (error: any) {
    console.error('注册失败:', error);
    ElMessage.error('注册失败');
  } finally {
    loading.value = false;
  }
};

// 页面卸载时清理轮询
onUnmounted(() => {
  stopPolling();
  stopMiniprogramCountdown();
  stopRegisterCountdown(); // 清理注册倒计时
  isGeneratingCode.value = false;
  
  // 清理窗口大小监听器
  window.removeEventListener('resize', handleResize);
  
  // 新增：清理事件监听器
  // 注意：由于使用了匿名函数，这里无法直接移除，但不会造成内存泄漏
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_t_icon = _resolveComponent("t-icon")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showLoginStatusChangeTip.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_alert, {
            title: "登录状态变化，请刷新",
            type: "info",
            closable: false,
            "show-icon": ""
          }, {
            default: _withCtx(() => [
              _cache[14] || (_cache[14] = _createElementVNode("p", null, "检测到其他标签页已完成登录，请刷新页面以同步最新状态。", -1)),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "small",
                  onClick: refreshPage
                }, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                    _createTextVNode(" 刷新页面 ")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  size: "small",
                  onClick: dismissTip
                }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createTextVNode(" 忽略 ")
                  ])),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (!logoLoaded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[15] || (_cache[15] = [
          _createElementVNode("div", { class: "loading-spinner" }, null, -1),
          _createElementVNode("p", null, "加载中...", -1)
        ])))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["logo-container", { 'animation-complete': animationComplete.value }])
    }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "Logo",
        class: "logo",
        ref_key: "logoRef",
        ref: logoRef,
        onLoad: handleLogoLoaded,
        onError: handleLogoError
      }, null, 544),
      _createElementVNode("h1", {
        class: _normalizeClass(["system-title", { 'show': animationComplete.value }])
      }, "E时代 统一认证中心", 2)
    ], 2), [
      [_vShow, logoLoaded.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      (isDesktop.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["unified-login-card", { 'show': animationComplete.value }])
          }, [
            _createElementVNode("div", _hoisted_6, [
              _cache[28] || (_cache[28] = _createElementVNode("div", { class: "section-header" }, [
                _createElementVNode("h2", null, "登录 / 注册")
              ], -1)),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_Transition, {
                    name: "email-slide",
                    mode: "out-in"
                  }, {
                    default: _withCtx(() => [
                      (!emailCodeSent.value && !showPasswordField.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createVNode(_component_el_form, {
                              model: formData,
                              onKeypress: _withKeys(selectPasswordLogin, ["enter"])
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, { label: "邮箱/用户名" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: formData.username,
                                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.username) = $event)),
                                      placeholder: "邮箱或用户名",
                                      clearable: "",
                                      onClear: handleClearUsername
                                    }, {
                                      prefix: _withCtx(() => [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(User))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["model"]),
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_el_button, {
                                type: isEmailFormat.value ? 'primary' : 'default',
                                onClick: startEmailCodeLogin,
                                loading: sendingCode.value,
                                class: "method-btn"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Message))
                                    ]),
                                    _: 1
                                  }),
                                  _cache[16] || (_cache[16] = _createTextVNode(" 邮箱验证码登录 "))
                                ]),
                                _: 1
                              }, 8, ["type", "loading"]),
                              _createVNode(_component_el_button, {
                                type: isEmailFormat.value ? 'default' : 'primary',
                                onClick: selectPasswordLogin,
                                class: "method-btn"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Lock))
                                    ]),
                                    _: 1
                                  }),
                                  _cache[17] || (_cache[17] = _createTextVNode(" 密码登录 "))
                                ]),
                                _: 1
                              }, 8, ["type"]),
                              _createVNode(_component_el_button, {
                                onClick: handlePasskeyLogin,
                                loading: passkeyLoginLoading.value,
                                class: "method-btn"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Key))
                                    ]),
                                    _: 1
                                  }),
                                  _cache[18] || (_cache[18] = _createTextVNode(" 通行密钥 "))
                                ]),
                                _: 1
                              }, 8, ["loading"])
                            ])
                          ]))
                        : (!emailCodeSent.value && showPasswordField.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createVNode(_component_el_form, {
                                ref_key: "accountFormRef",
                                ref: accountFormRef,
                                model: formData,
                                rules: rules,
                                onKeypress: _withKeys(handleSubmit, ["enter"])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "username",
                                    label: "邮箱/用户名"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: formData.username,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.username) = $event)),
                                        placeholder: "邮箱或用户名",
                                        clearable: "",
                                        onClear: handleClearUsername
                                      }, {
                                        prefix: _withCtx(() => [
                                          _createVNode(_component_el_icon, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(User))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_form_item, {
                                    prop: "password",
                                    label: "密码"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: formData.password,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.password) = $event)),
                                        type: showPassword.value ? 'text' : 'password',
                                        placeholder: "密码",
                                        autofocus: ""
                                      }, {
                                        prefix: _withCtx(() => [
                                          _createVNode(_component_el_icon, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(Lock))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        suffix: _withCtx(() => [
                                          _createVNode(_component_el_icon, {
                                            class: "cursor-pointer",
                                            onClick: _cache[2] || (_cache[2] = ($event: any) => (showPassword.value = !showPassword.value))
                                          }, {
                                            default: _withCtx(() => [
                                              (showPassword.value)
                                                ? (_openBlock(), _createBlock(_unref(Hide), { key: 0 }))
                                                : (_openBlock(), _createBlock(_unref(View), { key: 1 }))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "type"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["model"])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                  _createVNode(_component_el_icon, { class: "code-sent-icon" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Message))
                                    ]),
                                    _: 1
                                  }),
                                  _createElementVNode("span", _hoisted_15, _toDisplayString(emailFormData.email), 1),
                                  _createVNode(_component_el_button, {
                                    text: "",
                                    type: "primary",
                                    size: "small",
                                    onClick: resetEmailCodeStep
                                  }, {
                                    default: _withCtx(() => _cache[19] || (_cache[19] = [
                                      _createTextVNode("修改")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _cache[20] || (_cache[20] = _createElementVNode("span", { class: "code-sent-hint" }, "请输入邮箱收到的6位验证码", -1))
                              ]),
                              _createElementVNode("div", _hoisted_16, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (_, index) => {
                                  return _createElementVNode("input", {
                                    key: index,
                                    ref_for: true,
                                    ref: el => setPinRef(el, index),
                                    type: "text",
                                    inputmode: "numeric",
                                    maxlength: "1",
                                    class: _normalizeClass(["pin-code-input", { 'has-value': emailCodeDigits.value[index] }]),
                                    value: emailCodeDigits.value[index],
                                    onInput: ($event: any) => (handlePinInput(index, $event)),
                                    onKeydown: ($event: any) => (handlePinKeydown(index, $event)),
                                    onPaste: _cache[4] || (_cache[4] = ($event: any) => (handlePinPaste($event))),
                                    onFocus: ($event: any) => (handlePinFocus(index))
                                  }, null, 42, _hoisted_17)
                                }), 64))
                              ]),
                              _createElementVNode("div", _hoisted_18, [
                                (countdown.value > 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(countdown.value) + "秒后可重新获取", 1))
                                  : (_openBlock(), _createBlock(_component_el_button, {
                                      key: 1,
                                      text: "",
                                      type: "primary",
                                      size: "small",
                                      onClick: triggerEmailSendCodeCaptcha,
                                      loading: sendingCode.value
                                    }, {
                                      default: _withCtx(() => _cache[21] || (_cache[21] = [
                                        _createTextVNode(" 重新获取验证码 ")
                                      ])),
                                      _: 1
                                    }, 8, ["loading"]))
                              ])
                            ]))
                    ]),
                    _: 1
                  })
                ]),
                (showPasswordField.value || emailCodeSent.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: handleSubmit,
                        loading: loading.value,
                        class: "login-btn"
                      }, {
                        default: _withCtx(() => _cache[22] || (_cache[22] = [
                          _createTextVNode(" 登录 ")
                        ])),
                        _: 1
                      }, 8, ["loading"]),
                      (showPasswordField.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "back-link",
                            onClick: backToMethodSelect
                          }, " ← 返回选择登录方式 "))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_el_button, {
                    text: "",
                    onClick: goToRegister
                  }, {
                    default: _withCtx(() => _cache[23] || (_cache[23] = [
                      _createTextVNode("没有账号？立即注册")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    text: "",
                    onClick: showPasswordRecoveryTip
                  }, {
                    default: _withCtx(() => _cache[24] || (_cache[24] = [
                      _createTextVNode("忘记密码？")
                    ])),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _cache[27] || (_cache[27] = _createElementVNode("div", { class: "divider" }, [
                    _createElementVNode("span", null, "其他登录方式")
                  ], -1)),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_t_icon, {
                      name: "logo-qq",
                      onClick: handleQQLogin
                    }),
                    _createVNode(_component_el_icon, {
                      class: "oauth-icon",
                      onClick: handleGoogleLogin
                    }, {
                      default: _withCtx(() => _cache[25] || (_cache[25] = [
                        _createElementVNode("svg", {
                          viewBox: "0 0 48 48",
                          width: "1em",
                          height: "1em"
                        }, [
                          _createElementVNode("path", {
                            fill: "#FFC107",
                            d: "M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12 s5.373-12,12-12c3.059,0,5.842,1.154,7.957,3.043l5.657-5.657C33.754,6.053,29.131,4,24,4C12.955,4,4,12.955,4,24 s8.955,20,20,20s20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
                          }),
                          _createElementVNode("path", {
                            fill: "#FF3D00",
                            d: "M6.306,14.691l6.571,4.819C14.655,16.108,18.961,13,24,13c3.059,0,5.842,1.154,7.957,3.043l5.657-5.657 C33.754,6.053,29.131,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
                          }),
                          _createElementVNode("path", {
                            fill: "#4CAF50",
                            d: "M24,44c5.166,0,9.859-1.977,13.409-5.193l-6.19-5.238C29.211,35.091,26.715,36,24,36 c-5.202,0-9.619-3.317-11.278-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
                          }),
                          _createElementVNode("path", {
                            fill: "#1976D2",
                            d: "M43.611,20.083H42V20H24v8h11.303c-0.794,2.237-2.231,4.166-3.987,5.569 c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.988,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
                          })
                        ], -1)
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_icon, {
                      class: "oauth-icon",
                      onClick: handleGithubLogin
                    }, {
                      default: _withCtx(() => _cache[26] || (_cache[26] = [
                        _createElementVNode("svg", {
                          viewBox: "0 0 24 24",
                          width: "1em",
                          height: "1em"
                        }, [
                          _createElementVNode("path", {
                            fill: "currentColor",
                            d: "M12 0C5.37 0 0 5.37 0 12a12 12 0 0 0 8.21 11.44c.6.11.82-.26.82-.58v-2.02c-3.34.73-4.04-1.61-4.04-1.61c-.55-1.39-1.35-1.76-1.35-1.76c-1.11-.76.08-.75.08-.75c1.22.09 1.86 1.25 1.86 1.25c1.09 1.86 2.86 1.32 3.56 1.01c.11-.79.43-1.32.78-1.62c-2.66-.3-5.47-1.33-5.47-5.93c0-1.31.47-2.38 1.24-3.22c-.12-.3-.54-1.52.12-3.17c0 0 1.01-.32 3.3 1.23c.96-.27 1.98-.4 3-.41c1.02.01 2.04.14 3 .41c2.29-1.55 3.3-1.23 3.3-1.23c.66 1.65.24 2.87.12 3.17c.77.84 1.24 1.91 1.24 3.22c0 4.61-2.81 5.63-5.49 5.92c.44.38.83 1.13.83 2.28v3.38c0 .32.22.69.82.58A12 12 0 0 0 24 12c0-6.63-5.37-12-12-12z"
                          })
                        ], -1)
                      ])),
                      _: 1
                    })
                  ])
                ])
              ])), [
                [_directive_loading, loading.value]
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(GeetestCaptcha, {
                  ref_key: "accountBindGeetestRef",
                  ref: accountBindGeetestRef,
                  product: "bind",
                  onSuccess: onAccountBindSuccess
                }, null, 512),
                _createVNode(GeetestCaptcha, {
                  ref_key: "emailBindGeetestRef",
                  ref: emailBindGeetestRef,
                  product: "bind",
                  onSuccess: onEmailBindSuccess
                }, null, 512)
              ])
            ]),
            _cache[48] || (_cache[48] = _createElementVNode("div", { class: "card-divider" }, [
              _createElementVNode("span", { class: "divider-text" }, "或")
            ], -1)),
            _createElementVNode("div", {
              class: _normalizeClass(["wechat-scan-section", { 'show': sidePanelsVisible.value }])
            }, [
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_el_icon, { class: "wechat-icon" }, {
                  default: _withCtx(() => _cache[29] || (_cache[29] = [
                    _createElementVNode("svg", {
                      viewBox: "0 0 24 24",
                      width: "1em",
                      height: "1em"
                    }, [
                      _createElementVNode("path", {
                        fill: "#07C160",
                        d: "M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 0 1 .213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 0 0 .167-.054l1.903-1.114a.864.864 0 0 1 .717-.098 10.16 10.16 0 0 0 2.837.403c.276 0 .543-.027.811-.05-.857-2.578.157-4.972 1.932-6.446 1.703-1.415 3.882-1.98 5.853-1.838-.576-3.583-4.196-6.348-8.596-6.348zM5.785 5.991c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178A1.17 1.17 0 0 1 4.623 7.17c0-.651.52-1.18 1.162-1.18zm5.813 0c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178 1.17 1.17 0 0 1-1.162-1.178c0-.651.52-1.18 1.162-1.18zm5.34 2.867c-1.797-.052-3.746.512-5.28 1.786-1.72 1.428-2.687 3.72-1.78 6.22.942 2.453 3.666 4.229 6.884 4.229.826 0 1.622-.12 2.361-.336a.722.722 0 0 1 .598.082l1.584.926a.272.272 0 0 0 .14.047c.134 0 .24-.111.24-.247 0-.06-.023-.12-.038-.177l-.327-1.233a.582.582 0 0 1-.023-.156.49.49 0 0 1 .201-.398C23.024 18.48 24 16.82 24 14.98c0-3.21-2.931-5.837-6.656-6.088V8.89c-.135-.006-.27-.012-.405-.012v-.03zm-2.53 3.274c.535 0 .969.44.969.982a.976.976 0 0 1-.969.983.976.976 0 0 1-.969-.983c0-.542.434-.982.97-.982zm4.844 0c.535 0 .969.44.969.982a.976.976 0 0 1-.969.983.976.976 0 0 1-.969-.983c0-.542.434-.982.969-.982z"
                      })
                    ], -1)
                  ])),
                  _: 1
                }),
                _cache[30] || (_cache[30] = _createElementVNode("h2", null, "微信扫码登录", -1))
              ]),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  (miniprogramQrImage.value)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: miniprogramQrImage.value,
                        alt: "微信小程序扫码登录",
                        class: "wechat-qr-code"
                      }, null, 8, _hoisted_28))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "wechat-qr-placeholder",
                        onClick: generateMiniprogramCode
                      }, [
                        (miniprogramStatus.value === 'expired')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createVNode(_component_el_icon, { class: "qr-expired-icon" }, {
                                default: _withCtx(() => _cache[31] || (_cache[31] = [
                                  _createElementVNode("svg", {
                                    viewBox: "0 0 24 24",
                                    width: "1em",
                                    height: "1em"
                                  }, [
                                    _createElementVNode("path", {
                                      fill: "currentColor",
                                      d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
                                    })
                                  ], -1)
                                ])),
                                _: 1
                              }),
                              _cache[32] || (_cache[32] = _createElementVNode("p", { class: "qr-placeholder-text" }, "小程序码已失效", -1)),
                              _cache[33] || (_cache[33] = _createElementVNode("p", { class: "qr-placeholder-subtext" }, "点击重新生成", -1))
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createVNode(_component_el_icon, { class: "qr-placeholder-icon" }, {
                                default: _withCtx(() => _cache[34] || (_cache[34] = [
                                  _createElementVNode("svg", {
                                    viewBox: "0 0 24 24",
                                    width: "1em",
                                    height: "1em"
                                  }, [
                                    _createElementVNode("path", {
                                      fill: "currentColor",
                                      d: "M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 0 1 .213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 0 0 .167-.054l1.903-1.114a.864.864 0 0 1 .717-.098 10.16 10.16 0 0 0 2.837.403c.276 0 .543-.027.811-.05-.857-2.578.157-4.972 1.932-6.446 1.703-1.415 3.882-1.98 5.853-1.838-.576-3.583-4.196-6.348-8.596-6.348zM5.785 5.991c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178A1.17 1.17 0 0 1 4.623 7.17c0-.651.52-1.18 1.162-1.18zm5.813 0c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178 1.17 1.17 0 0 1-1.162-1.178c0-.651.52-1.18 1.162-1.18zm5.34 2.867c-1.797-.052-3.746.512-5.28 1.786-1.72 1.428-2.687 3.72-1.78 6.22.942 2.453 3.666 4.229 6.884 4.229.826 0 1.622-.12 2.361-.336a.722.722 0 0 1 .598.082l1.584.926a.272.272 0 0 0 .14.047c.134 0 .24-.111.24-.247 0-.06-.023-.12-.038-.177l-.327-1.233a.582.582 0 0 1-.023-.156.49.49 0 0 1 .201-.398C23.024 18.48 24 16.82 24 14.98c0-3.21-2.931-5.837-6.656-6.088V8.89c-.135-.006-.27-.012-.405-.012v-.03zm-2.53 3.274c.535 0 .969.44.969.982a.976.976 0 0 1-.969.983.976.976 0 0 1-.969-.983c0-.542.434-.982.97-.982zm4.844 0c.535 0 .969.44.969.982a.976.976 0 0 1-.969.983.976.976 0 0 1-.969-.983c0-.542.434-.982.969-.982z"
                                    })
                                  ], -1)
                                ])),
                                _: 1
                              }),
                              _cache[35] || (_cache[35] = _createElementVNode("p", { class: "qr-placeholder-text" }, "点击生成小程序码", -1))
                            ], 64))
                      ]))
                ]),
                _createElementVNode("div", _hoisted_29, [
                  (miniprogramCountdown.value > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createElementVNode("span", _hoisted_31, "有效期：" + _toDisplayString(formatCountdown(miniprogramCountdown.value)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (miniprogramCode.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _cache[36] || (_cache[36] = _createElementVNode("span", { class: "code-label" }, "识别码：", -1)),
                        _createElementVNode("span", _hoisted_33, _toDisplayString(miniprogramCode.value.slice(0, 5)) + "-" + _toDisplayString(miniprogramCode.value.slice(5, 10)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (miniprogramQrImage.value && miniprogramCountdown.value <= 0)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 2,
                        type: "primary",
                        text: "",
                        size: "small",
                        onClick: generateMiniprogramCode,
                        loading: miniprogramLoading.value
                      }, {
                        default: _withCtx(() => _cache[37] || (_cache[37] = [
                          _createTextVNode(" 重新生成 ")
                        ])),
                        _: 1
                      }, 8, ["loading"]))
                    : _createCommentVNode("", true)
                ]),
                _cache[47] || (_cache[47] = _createElementVNode("p", { class: "wechat-tip" }, "微信扫一扫，确认即可登录", -1)),
                (miniprogramStatus.value !== 'waiting')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      (miniprogramStatus.value === 'confirmed')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                            _createVNode(_component_el_icon, { class: "status-icon" }, {
                              default: _withCtx(() => _cache[38] || (_cache[38] = [
                                _createElementVNode("svg", {
                                  viewBox: "0 0 24 24",
                                  width: "1em",
                                  height: "1em"
                                }, [
                                  _createElementVNode("path", {
                                    fill: "currentColor",
                                    d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
                                  })
                                ], -1)
                              ])),
                              _: 1
                            }),
                            _cache[39] || (_cache[39] = _createElementVNode("p", null, "授权已确认，正在登录...", -1))
                          ]))
                        : (miniprogramStatus.value === 'expired')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                              _cache[41] || (_cache[41] = _createElementVNode("p", null, "小程序码已失效", -1)),
                              _createVNode(_component_el_button, {
                                type: "primary",
                                text: "",
                                size: "small",
                                onClick: generateMiniprogramCode
                              }, {
                                default: _withCtx(() => _cache[40] || (_cache[40] = [
                                  _createTextVNode("重新生成")
                                ])),
                                _: 1
                              })
                            ]))
                          : (miniprogramStatus.value === 'register')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                _cache[46] || (_cache[46] = _createElementVNode("p", { class: "status-subtitle" }, "该微信未绑定账号", -1)),
                                (registerCountdown.value > 0)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_38, [
                                      _cache[42] || (_cache[42] = _createTextVNode(" 将在 ")),
                                      _createElementVNode("span", _hoisted_39, _toDisplayString(registerCountdown.value), 1),
                                      _cache[43] || (_cache[43] = _createTextVNode(" 秒后自动创建 "))
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_40, [
                                  _createVNode(_component_el_button, {
                                    size: "small",
                                    onClick: cancelRegister
                                  }, {
                                    default: _withCtx(() => _cache[44] || (_cache[44] = [
                                      _createTextVNode("取消")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    size: "small",
                                    onClick: confirmRegister,
                                    loading: loading.value
                                  }, {
                                    default: _withCtx(() => _cache[45] || (_cache[45] = [
                                      _createTextVNode("立即注册")
                                    ])),
                                    _: 1
                                  }, 8, ["loading"])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])), [
                [_directive_loading, miniprogramLoading.value]
              ])
            ], 2)
          ], 2))
        : _createCommentVNode("", true),
      (!isDesktop.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["login-box", { 'show': animationComplete.value }])
          }, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", {
                class: _normalizeClass(["content-wrapper", { 'show': animationComplete.value }])
              }, [
                _cache[49] || (_cache[49] = _createElementVNode("h2", null, "登录 / 注册", -1)),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("span", {
                    class: _normalizeClass(['tab', currentMethod.value === 'account' ? 'active' : '']),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (currentMethod.value = 'account'))
                  }, " 登录 / 注册 ", 2),
                  _createElementVNode("span", {
                    class: _normalizeClass(['tab', currentMethod.value === 'miniprogram' ? 'active' : '']),
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (currentMethod.value = 'miniprogram'))
                  }, " 微信登录 ", 2)
                ])
              ], 2)
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["login-content", { 'show': animationComplete.value }])
            }, [
              _createVNode(_Transition, {
                name: "fade",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  (currentMethod.value === 'account')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                        _createVNode(_Transition, {
                          name: "email-slide",
                          mode: "out-in"
                        }, {
                          default: _withCtx(() => [
                            (!emailCodeSent.value && !showPasswordField.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                  _createVNode(_component_el_form, {
                                    model: formData,
                                    onKeypress: _withKeys(selectPasswordLogin, ["enter"])
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_form_item, { label: "邮箱/用户名" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_input, {
                                            modelValue: formData.username,
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.username) = $event)),
                                            placeholder: "邮箱或用户名",
                                            clearable: "",
                                            onClear: handleClearUsername
                                          }, {
                                            prefix: _withCtx(() => [
                                              _createVNode(_component_el_icon, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(User))
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["model"]),
                                  _createElementVNode("div", _hoisted_45, [
                                    _createVNode(_component_el_button, {
                                      type: isEmailFormat.value ? 'primary' : 'default',
                                      onClick: startEmailCodeLogin,
                                      loading: sendingCode.value,
                                      class: "method-btn"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(Message))
                                          ]),
                                          _: 1
                                        }),
                                        _cache[50] || (_cache[50] = _createTextVNode(" 邮箱验证码登录 "))
                                      ]),
                                      _: 1
                                    }, 8, ["type", "loading"]),
                                    _createVNode(_component_el_button, {
                                      type: isEmailFormat.value ? 'default' : 'primary',
                                      onClick: selectPasswordLogin,
                                      class: "method-btn"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(Lock))
                                          ]),
                                          _: 1
                                        }),
                                        _cache[51] || (_cache[51] = _createTextVNode(" 密码登录 "))
                                      ]),
                                      _: 1
                                    }, 8, ["type"]),
                                    _createVNode(_component_el_button, {
                                      onClick: handlePasskeyLogin,
                                      loading: passkeyLoginLoading.value,
                                      class: "method-btn"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(Key))
                                          ]),
                                          _: 1
                                        }),
                                        _cache[52] || (_cache[52] = _createTextVNode(" 通行密钥 "))
                                      ]),
                                      _: 1
                                    }, 8, ["loading"])
                                  ])
                                ]))
                              : (!emailCodeSent.value && showPasswordField.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                    _createVNode(_component_el_form, {
                                      ref_key: "accountFormRef",
                                      ref: accountFormRef,
                                      model: formData,
                                      rules: rules,
                                      onKeypress: _withKeys(handleSubmit, ["enter"])
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_form_item, {
                                          prop: "username",
                                          label: "邮箱/用户名"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_input, {
                                              modelValue: formData.username,
                                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.username) = $event)),
                                              placeholder: "邮箱或用户名",
                                              clearable: "",
                                              onClear: handleClearUsername
                                            }, {
                                              prefix: _withCtx(() => [
                                                _createVNode(_component_el_icon, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_unref(User))
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_form_item, {
                                          prop: "password",
                                          label: "密码"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_input, {
                                              modelValue: formData.password,
                                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.password) = $event)),
                                              type: showPassword.value ? 'text' : 'password',
                                              placeholder: "密码",
                                              autofocus: ""
                                            }, {
                                              prefix: _withCtx(() => [
                                                _createVNode(_component_el_icon, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_unref(Lock))
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              suffix: _withCtx(() => [
                                                _createVNode(_component_el_icon, {
                                                  class: "cursor-pointer",
                                                  onClick: _cache[9] || (_cache[9] = ($event: any) => (showPassword.value = !showPassword.value))
                                                }, {
                                                  default: _withCtx(() => [
                                                    (showPassword.value)
                                                      ? (_openBlock(), _createBlock(_unref(Hide), { key: 0 }))
                                                      : (_openBlock(), _createBlock(_unref(View), { key: 1 }))
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue", "type"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["model"])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                    _createElementVNode("div", _hoisted_48, [
                                      _createElementVNode("div", _hoisted_49, [
                                        _createVNode(_component_el_icon, { class: "code-sent-icon" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(Message))
                                          ]),
                                          _: 1
                                        }),
                                        _createElementVNode("span", _hoisted_50, _toDisplayString(emailFormData.email), 1),
                                        _createVNode(_component_el_button, {
                                          text: "",
                                          type: "primary",
                                          size: "small",
                                          onClick: resetEmailCodeStep
                                        }, {
                                          default: _withCtx(() => _cache[53] || (_cache[53] = [
                                            _createTextVNode("修改")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _cache[54] || (_cache[54] = _createElementVNode("span", { class: "code-sent-hint" }, "请输入邮箱收到的6位验证码", -1))
                                    ]),
                                    _createElementVNode("div", _hoisted_51, [
                                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (_, index) => {
                                        return _createElementVNode("input", {
                                          key: index,
                                          ref_for: true,
                                          ref: el => setPinRef(el, index),
                                          type: "text",
                                          inputmode: "numeric",
                                          maxlength: "1",
                                          class: _normalizeClass(["pin-code-input", { 'has-value': emailCodeDigits.value[index] }]),
                                          value: emailCodeDigits.value[index],
                                          onInput: ($event: any) => (handlePinInput(index, $event)),
                                          onKeydown: ($event: any) => (handlePinKeydown(index, $event)),
                                          onPaste: _cache[11] || (_cache[11] = ($event: any) => (handlePinPaste($event))),
                                          onFocus: ($event: any) => (handlePinFocus(index))
                                        }, null, 42, _hoisted_52)
                                      }), 64))
                                    ]),
                                    _createElementVNode("div", _hoisted_53, [
                                      (countdown.value > 0)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(countdown.value) + "秒后可重新获取", 1))
                                        : (_openBlock(), _createBlock(_component_el_button, {
                                            key: 1,
                                            text: "",
                                            type: "primary",
                                            size: "small",
                                            onClick: triggerEmailSendCodeCaptcha,
                                            loading: sendingCode.value
                                          }, {
                                            default: _withCtx(() => _cache[55] || (_cache[55] = [
                                              _createTextVNode(" 重新获取验证码 ")
                                            ])),
                                            _: 1
                                          }, 8, ["loading"]))
                                    ])
                                  ]))
                          ]),
                          _: 1
                        })
                      ]))
                    : (currentMethod.value === 'miniprogram')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                          _createElementVNode("div", _hoisted_56, [
                            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_57, [
                              _createElementVNode("div", _hoisted_58, [
                                _createElementVNode("div", _hoisted_59, [
                                  (miniprogramQrImage.value)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: miniprogramQrImage.value,
                                        alt: "微信小程序扫码登录",
                                        class: "miniprogram-qr-code"
                                      }, null, 8, _hoisted_60))
                                    : (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        class: "miniprogram-qr-placeholder",
                                        onClick: generateMiniprogramCode
                                      }, [
                                        (miniprogramStatus.value === 'expired')
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createVNode(_component_el_icon, { class: "qr-expired-icon" }, {
                                                default: _withCtx(() => _cache[56] || (_cache[56] = [
                                                  _createElementVNode("svg", {
                                                    viewBox: "0 0 24 24",
                                                    width: "1em",
                                                    height: "1em"
                                                  }, [
                                                    _createElementVNode("path", {
                                                      fill: "currentColor",
                                                      d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
                                                    })
                                                  ], -1)
                                                ])),
                                                _: 1
                                              }),
                                              _cache[57] || (_cache[57] = _createElementVNode("p", { class: "qr-placeholder-text" }, "小程序码已失效", -1)),
                                              _cache[58] || (_cache[58] = _createElementVNode("p", { class: "qr-placeholder-subtext" }, "点击重新生成", -1))
                                            ], 64))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createVNode(_component_el_icon, { class: "qr-placeholder-icon" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(Key))
                                                ]),
                                                _: 1
                                              }),
                                              _cache[59] || (_cache[59] = _createElementVNode("p", { class: "qr-placeholder-text" }, "点击下方按钮生成小程序码", -1))
                                            ], 64))
                                      ])),
                                  _cache[60] || (_cache[60] = _createElementVNode("p", { class: "qr-tip" }, " 微信扫一扫，小程序中点“确认”即可完成登录 ", -1)),
                                  (miniprogramCountdown.value > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                        _createElementVNode("span", _hoisted_62, "小程序码有效期：" + _toDisplayString(formatCountdown(miniprogramCountdown.value)), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                (miniprogramCode.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                      _cache[62] || (_cache[62] = _createElementVNode("span", { class: "code-label" }, "识别码：", -1)),
                                      _createElementVNode("span", _hoisted_64, [
                                        _createElementVNode("span", _hoisted_65, _toDisplayString(miniprogramCode.value.slice(0, 5)), 1),
                                        _cache[61] || (_cache[61] = _createElementVNode("span", { class: "code-separator" }, "-", -1)),
                                        _createElementVNode("span", _hoisted_66, _toDisplayString(miniprogramCode.value.slice(5, 10)), 1)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  onClick: generateMiniprogramCode,
                                  disabled: miniprogramCountdown.value > 0,
                                  loading: miniprogramLoading.value
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(miniprogramCountdown.value > 0 ? `${formatCountdown(miniprogramCountdown.value)} 后可重新获取` : (miniprogramQrImage.value ? '重新生成小程序码' : '生成小程序码')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["disabled", "loading"]),
                                (miniprogramStatus.value !== 'waiting')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                      (miniprogramStatus.value === 'confirmed')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_68, _cache[63] || (_cache[63] = [
                                            _createElementVNode("p", null, "授权已确认，正在为你登录...", -1)
                                          ])))
                                        : (miniprogramStatus.value === 'expired')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                              _cache[65] || (_cache[65] = _createElementVNode("p", null, "小程序码已失效，请重新生成", -1)),
                                              _createVNode(_component_el_button, {
                                                type: "primary",
                                                text: "",
                                                onClick: generateMiniprogramCode
                                              }, {
                                                default: _withCtx(() => _cache[64] || (_cache[64] = [
                                                  _createTextVNode("重新生成")
                                                ])),
                                                _: 1
                                              })
                                            ]))
                                          : (miniprogramStatus.value === 'register')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                                _cache[69] || (_cache[69] = _createElementVNode("p", { class: "status-subtitle" }, "该微信未绑定账号", -1)),
                                                (registerCountdown.value > 0)
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_71, [
                                                      _cache[66] || (_cache[66] = _createTextVNode(" 将在 ")),
                                                      _createElementVNode("span", _hoisted_72, _toDisplayString(registerCountdown.value), 1),
                                                      _cache[67] || (_cache[67] = _createTextVNode(" 秒后自动创建新账号 "))
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                _createElementVNode("div", _hoisted_73, [
                                                  _createVNode(_component_el_button, { onClick: cancelRegister }, {
                                                    default: _withCtx(() => _cache[68] || (_cache[68] = [
                                                      _createTextVNode("取消")
                                                    ])),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_el_button, {
                                                    type: "primary",
                                                    onClick: confirmRegister,
                                                    loading: loading.value
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(registerCountdown.value > 0 ? `立即注册 (${registerCountdown.value}s)` : '注册新账号'), 1)
                                                    ]),
                                                    _: 1
                                                  }, 8, ["loading"])
                                                ])
                                              ]))
                                            : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])), [
                              [_directive_loading, miniprogramLoading.value]
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (currentMethod.value !== 'miniprogram')
                ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                    (showPasswordField.value || emailCodeSent.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: handleSubmit,
                            loading: loading.value,
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => _cache[70] || (_cache[70] = [
                              _createTextVNode(" 登录 ")
                            ])),
                            _: 1
                          }, 8, ["loading"]),
                          (showPasswordField.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "back-link",
                                onClick: backToMethodSelect
                              }, " ← 返回选择登录方式 "))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_76, [
                      _createVNode(_component_el_button, {
                        text: "",
                        onClick: goToRegister
                      }, {
                        default: _withCtx(() => _cache[71] || (_cache[71] = [
                          _createTextVNode(" 没有账号？立即注册 ")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        text: "",
                        onClick: showPasswordRecoveryTip
                      }, {
                        default: _withCtx(() => _cache[72] || (_cache[72] = [
                          _createTextVNode("忘记密码？")
                        ])),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_77, [
                _cache[75] || (_cache[75] = _createElementVNode("div", { class: "divider" }, [
                  _createElementVNode("span", null, "其他登录方式")
                ], -1)),
                _createElementVNode("div", _hoisted_78, [
                  _createVNode(_unref(LogoQqIcon), { onClick: handleQQLogin }),
                  _createVNode(_component_el_icon, {
                    class: "oauth-icon",
                    onClick: handleGoogleLogin
                  }, {
                    default: _withCtx(() => _cache[73] || (_cache[73] = [
                      _createElementVNode("svg", {
                        viewBox: "0 0 48 48",
                        width: "1em",
                        height: "1em"
                      }, [
                        _createElementVNode("path", {
                          fill: "#FFC107",
                          d: "M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12 s5.373-12,12-12c3.059,0,5.842,1.154,7.957,3.043l5.657-5.657C33.754,6.053,29.131,4,24,4C12.955,4,4,12.955,4,24 s8.955,20,20,20s20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
                        }),
                        _createElementVNode("path", {
                          fill: "#FF3D00",
                          d: "M6.306,14.691l6.571,4.819C14.655,16.108,18.961,13,24,13c3.059,0,5.842,1.154,7.957,3.043l5.657-5.657 C33.754,6.053,29.131,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
                        }),
                        _createElementVNode("path", {
                          fill: "#4CAF50",
                          d: "M24,44c5.166,0,9.859-1.977,13.409-5.193l-6.19-5.238C29.211,35.091,26.715,36,24,36 c-5.202,0-9.619-3.317-11.278-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
                        }),
                        _createElementVNode("path", {
                          fill: "#1976D2",
                          d: "M43.611,20.083H42V20H24v8h11.303c-0.794,2.237-2.231,4.166-3.987,5.569 c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.988,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
                        })
                      ], -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_el_icon, {
                    class: "oauth-icon",
                    onClick: handleGithubLogin
                  }, {
                    default: _withCtx(() => _cache[74] || (_cache[74] = [
                      _createElementVNode("svg", {
                        viewBox: "0 0 24 24",
                        width: "1em",
                        height: "1em"
                      }, [
                        _createElementVNode("path", {
                          fill: "currentColor",
                          d: "M12 0C5.37 0 0 5.37 0 12a12 12 0 0 0 8.21 11.44c.6.11.82-.26.82-.58v-2.02c-3.34.73-4.04-1.61-4.04-1.61c-.55-1.39-1.35-1.76-1.35-1.76c-1.11-.76.08-.75.08-.75c1.22.09 1.86 1.25 1.86 1.25c1.09 1.86 2.86 1.32 3.56 1.01c.11-.79.43-1.32.78-1.62c-2.66-.3-5.47-1.33-5.47-5.93c0-1.31.47-2.38 1.24-3.22c-.12-.3-.54-1.52.12-3.17c0 0 1.01-.32 3.3 1.23c.96-.27 1.98-.4 3-.41c1.02.01 2.04.14 3 .41c2.29-1.55 3.3-1.23 3.3-1.23c.66 1.65.24 2.87.12 3.17c.77.84 1.24 1.91 1.24 3.22c0 4.61-2.81 5.63-5.49 5.92c.44.38.83 1.13.83 2.28v3.38c0 .32.22.69.82.58A12 12 0 0 0 24 12c0-6.63-5.37-12-12-12z"
                        })
                      ], -1)
                    ])),
                    _: 1
                  })
                ])
              ])
            ], 2)), [
              [_directive_loading, loading.value]
            ]),
            _createElementVNode("div", _hoisted_79, [
              _createVNode(GeetestCaptcha, {
                ref_key: "accountBindGeetestRef",
                ref: accountBindGeetestRef,
                product: "bind",
                onSuccess: onAccountBindSuccess
              }, null, 512),
              _createVNode(GeetestCaptcha, {
                ref_key: "emailBindGeetestRef",
                ref: emailBindGeetestRef,
                product: "bind",
                onSuccess: onEmailBindSuccess
              }, null, 512)
            ])
          ], 2))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, logoLoaded.value]
    ])
  ]))
}
}

})